import React from 'react';
import { RefreshCw, X } from 'lucide-react';
import { useVersionCheck } from '@/hooks/useVersionCheck';

const UpdateBanner = () => {
  const { updateAvailable, applyUpdate } = useVersionCheck();
  const [dismissed, setDismissed] = React.useState(false);

  if (!updateAvailable || dismissed) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-between
        gap-3 px-4 py-2.5 text-white text-sm shadow-lg animate-in slide-in-from-top"
      style={{ backgroundColor: '#001C60' }}
      data-testid="update-banner"
      role="status"
      aria-live="polite"
    >
      <span className="flex-1 text-center sm:text-left">
        A new version of Compass is available.
      </span>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          onClick={applyUpdate}
          className="flex items-center gap-1.5 bg-white text-[#001C60] px-3 py-1 rounded
            text-xs font-semibold hover:bg-blue-50 transition-colors"
          data-testid="update-now-button"
        >
          <RefreshCw className="w-3 h-3" />
          Update now
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="text-white/70 hover:text-white transition-colors p-0.5"
          aria-label="Dismiss update notification"
          data-testid="dismiss-update-button"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default UpdateBanner;
